<template>
  <div class="map-view-maps"></div>
</template>

<script>
import gmapsInit from "@/utils/gmaps";
import MarkerClusterer from "@google/markerclusterer";

export default {
  props: {
    activePosition: {
      type: Object,
      required: true
    }
  },
  computed: {
    pointFeatures() {
      return this.$store.state.ui.pointFeatures;
    },
    appAsset() {
      return this.activePosition.gemeente.app_asset
        ? this.activePosition.gemeente.app_asset
        : null;
    },
    loadedCategories() {
      return this.$store.state.data.loadedCategories;
    }
  },
  async mounted() {
    try {
      let self = this;

      gmapsInit().then(function(google) {
        var map = new google.maps.Map(self.$el, {
          disableDefaultUI: true
        });

        let position = {
          lat: self.activePosition.latitude,
          lng: self.activePosition.longitude
        };

        new google.maps.Marker({
          map: map,
          position: position,
          icon: {
            url: "/ic_location@2x.png",
            anchor: new google.maps.Point(16, 16),
            scaledSize: new google.maps.Size(32, 32)
          }
        });

        let circle = new google.maps.Circle({
          map: map,
          strokeWeight: 0,
          fillColor: self.appAsset ? self.appAsset.color_primary : "#6DCC00",
          fillOpacity: 0.33,
          center: position,
          radius: self.activePosition.radius
        });

        map.setCenter(position);
        map.fitBounds(circle.getBounds(), 0);

        let markers = [];

        self.pointFeatures.forEach(function(pointFeature) {
          let markerPosition = {
            lat: pointFeature.geometry.coordinates[1],
            lng: pointFeature.geometry.coordinates[0]
          };

          let category = self.loadedCategories.data.find(
            x => x.id == pointFeature.properties.category_id
          );

          let pointMarker = new google.maps.Marker({
            map: map,
            position: markerPosition,
            icon: {
              url: category.icon_url,
              anchor: new google.maps.Point(16, 16),
              scaledSize: new google.maps.Size(32, 32)
            }
          });

          pointMarker.addListener("click", function() {
            self.$store.commit("setActiveFeature", pointFeature);
            self.$store.commit("setReadFeatures", pointFeature);
          });

          markers.push(pointMarker);
        });

        new MarkerClusterer(map, markers, {
          imagePath: "https://web.omgevingsalert.nl/m"
        });
      });
    } catch (error) {
      console.error(error);
    }
  }
};
</script>

<style scoped lang="scss">
.map-view-maps {
  width: 100%;
  height: 100%;
}
</style>
